var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"plan__tag"},[_vm._v(" "+_vm._s(_vm.copy)+" "),(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }